var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallLogoOcx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3474 4.8291L24.0004 7.69074L15.2933 12.7184C15.2933 12.7184 9.96082 15.9413 6.12695 9.29678L8.83821 7.73234C8.83821 7.73234 10.6 11.6267 13.6537 9.85814C16.7073 8.08955 22.3474 4.8291 22.3474 4.8291Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.13744 9.27683L0.484375 6.41518L9.37679 1.28144C9.37679 1.28144 14.7093 -1.94143 18.5418 4.70305L15.8306 6.26748C15.8306 6.26748 14.0688 2.37318 11.0151 4.14173C7.96144 5.91028 2.13744 9.27683 2.13744 9.27683Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.411 9.20684C13.611 9.20684 14.5838 8.23403 14.5838 7.03407C14.5838 5.8341 13.611 4.86133 12.411 4.86133C11.211 4.86133 10.2383 5.8341 10.2383 7.03407C10.2383 8.23403 11.211 9.20684 12.411 9.20684Z",
    fill: "#FF931E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73823 12.5995C5.36492 12.5995 5.87296 12.0915 5.87296 11.4648C5.87296 10.8381 5.36492 10.3301 4.73823 10.3301C4.11155 10.3301 3.60352 10.8381 3.60352 11.4648C3.60352 12.0915 4.11155 12.5995 4.73823 12.5995Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8847 3.85342C20.5114 3.85342 21.0194 3.34539 21.0194 2.7187C21.0194 2.09202 20.5114 1.58398 19.8847 1.58398C19.258 1.58398 18.75 2.09202 18.75 2.7187C18.75 3.34539 19.258 3.85342 19.8847 3.85342Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoOcx);
export default __webpack_public_path__ + "static/media/small-logo-ocx.54b1656ed7eddffeed92d2f422b97a4b.svg";
export { ForwardRef as ReactComponent };